import { mapRoutesFromMd } from '@/utils/Route';

const pages = import.meta.glob('./content/*.md', { eager: true });

export const children = mapRoutesFromMd(pages, { prefix: 'faqs' });
